import {throttle} from '../../components/custom-lodash'; // eslint-disable-line

const $ = require('jquery');
const mobileHoverIntent = require('../../utils/mobilehoverintent');
const progress = require('../../utils/progress');
const util = require('../../utils/util');
const captcha = require('../../spam/captcha');
const googleRecaptcha = require('../googleRecaptcha');

/**
 * Checks if the offset height is less than scroll height
 *
 * @param {jQuery} element - element
 * @returns {boolean} - whether the offset height is less than scroll height
 */
const isOverflowing = function (element) {
    return element.offsetHeight < element.scrollHeight;
};

/**
 * Fixing the scroll
 *
 * @param {jQuery} $element - jQuery element
 */
const winOsScrollFix = function ($element) {
    const $miniCartProducts = $element.find('.mini-cart-products');
    if ($('html').hasClass('win-os') && $miniCartProducts.length) {
        if (isOverflowing($miniCartProducts.get(0))) {
            $miniCartProducts.addClass('win-os-scroll-fix');
        } else {
            $miniCartProducts.removeClass('win-os-scroll-fix');
        }
    }
};

const header = {
    /**
     * Initializes the header
     */
    init() {
        const $window = $(window);
        const $headerNavigation = $('.header-navigation');
        const $topCats = $headerNavigation.find('.li-level-1');
        const $headerIconNav = $('.header-icon-nav .nav-item.has-flyout');
        const $headerIconNavItem = $('.header-icon-nav .nav-item');
        const $rightSideNav = $('a.right-side-header-link');
        const $headerPromoBannerSlick = $('.js-header_slider-container');
        const $flyoutArrow = $('.menus-flyout-arrow-wrapper');

        let position = $window.scrollTop();
        let topCatsWasTouched = false;
        let headerIconNavWasTouched = false;

        // Push navClicked event to dataLayer when anything on top nav is clicked.
        $headerNavigation.find('a').on('click', function () {
            const $this = $(this);
            const dataCatNavParent = $this.closest('.li-level-1')[0].dataset.navParentCat.toLowerCase();
            let dataCatNavParentLvlTwo = '-';
            let dataCatNavParentLvlThree = '-';

            if ($this.hasClass('a-level-2')) {
                dataCatNavParentLvlTwo = $this.parent('[class^="li-level-2"]')[0].dataset.navSecondCat;
            } else if ($this.hasClass('a-level-3')) {
                dataCatNavParentLvlTwo = $this.parent('.li-level-3')[0].dataset.navParentCat;
                dataCatNavParentLvlThree = $this[0].dataset.navThirdCat;
            }

            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'navClicked',
                    clickedNavLevel1: dataCatNavParent,
                    clickedNavLevel2: dataCatNavParentLvlTwo,
                    clickedNavLevel3: dataCatNavParentLvlThree
                });
            }
        });

        $headerPromoBannerSlick.removeClass('hidden');
        $headerPromoBannerSlick.slick({
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            pauseOnHover: false,
            rtl: document.documentElement.lang === 'ar',
            dotsClass: 'slick-dots-custom',
            prevArrow: $('.js-header_slider-arrow-prev'),
            nextArrow: $('.js-header_slider-arrow-next')
        });

        $('.skip-to-content').on('click', function () {
            $('#main a:visible, #main input:visible').first().focus();
        });

        $flyoutArrow.on('keydown', function (event) {
            const $element = $(this);
            // Space or Enter
            if (event.keyCode === 32 || event.keyCode === 13) {
                event.preventDefault();
                $element
                    .attr('aria-expanded', (_, expanded) => (expanded === 'true' ? 'false' : 'true'))
                    .closest($headerIconNav)
                    .toggleClass('hover')
                    .find($rightSideNav)
                    .attr('aria-expanded', (_, expanded) => (expanded === 'true' ? 'false' : 'true'));
            }
        });

        $headerIconNavItem.on('focusin', function (e) {
            if ($(e.target).hasClass('right-side-header-link')) {
                $topCats.removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
            }
            $(this).closest('li').siblings().removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
        });

        $topCats.on('keydown', function (event) {
            const $element = $(this);
            if (event.keyCode === 40) {
                event.preventDefault();
                $element.addClass('hover').find($rightSideNav).attr('aria-expanded', 'true');
            } else if (event.keyCode === 27) {
                $element.removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
            }
        });

        $topCats.on('focusin', function () {
            $headerIconNavItem.removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
            $(this).closest('li').siblings().removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
        });

        const $body = $('.body');
        $body.addClass('scroll-in-top');

        $window.scroll(
            throttle(function () {
                const scroll = $window.scrollTop();

                if (scroll === 0) {
                    $body.addClass('scroll-in-top');
                    $body.removeClass('scroll-not-in-top');
                } else {
                    $body.addClass('scroll-not-in-top');
                    $body.removeClass('scroll-in-top');
                }

                if (scroll > position) {
                    const $header = $('.header');
                    if ($header.hasClass('active-search')) {
                        const $searchContainer = $('.header').find('.header-search');
                        if (!$searchContainer.find('.search-suggestions').is(':visible')) {
                            $header.removeClass('active-search');
                            $searchContainer.fadeOut();
                        }
                    }
                    $body.removeClass('scroll-up');
                } else {
                    $body.addClass('scroll-up');
                }

                position = scroll;
            }, 3000)
        );

        $topCats.each(function () {
            const element = this;
            const $element = $(element);

            mobileHoverIntent(
                element,
                function (event) {
                    const $this = $(this);

                    if ($this.find('.a-level-1').hasClass('has-sub-menu')) {
                        if (!$this.hasClass('touched')) {
                            event.preventDefault();
                        }
                        $topCats.removeClass('hover touched');
                        $this.addClass('hover touched');
                        $headerNavigation.addClass('active');
                        topCatsWasTouched = true;
                    } else {
                        $topCats.removeClass('hover touched');
                        $this.removeClass('hover touched');
                        $headerNavigation.removeClass('active');
                        topCatsWasTouched = false;
                    }
                },
                function () {
                    $element.addClass('hover');
                    $headerNavigation.addClass('active');
                },
                function () {
                    $element.removeClass('hover');
                    $headerNavigation.removeClass('active');
                }
            ).options({
                interval: 100,
                timeout: 0
            });
        });

        $headerIconNav.each(function () {
            const element = this;
            const $element = $(element);

            mobileHoverIntent(
                element,
                function (event) {
                    const $this = $(this);

                    if (!$this.hasClass('touched')) {
                        event.preventDefault();
                    }

                    $headerIconNav.removeClass('hover touched');
                    $this.addClass('hover touched');
                    headerIconNavWasTouched = true;
                },
                function () {
                    $element.siblings().removeClass('hover active');
                    $element.addClass('hover').find($rightSideNav).attr('aria-expanded', 'true');

                    $('body').trigger('header::flyoutshown', $element);

                    winOsScrollFix($element);
                },
                function () {
                    setTimeout(function () {
                        $element.removeClass('hover').find($rightSideNav).attr('aria-expanded', 'false');
                    }, 400);

                    setTimeout(function () {
                        winOsScrollFix($element);
                    }, 800);
                }
            ).options({
                interval: 300,
                timeout: 0
            });
        });

        $window.on('touchend', function () {
            if (!topCatsWasTouched) {
                $topCats.removeClass('hover touched');
                $headerNavigation.removeClass('active');
            }

            if (!headerIconNavWasTouched) {
                $headerIconNav.removeClass('hover touched');
            }

            topCatsWasTouched = false;
            headerIconNavWasTouched = false;
        });

        // IOS Overscrolling bug fix BSDDEV-547
        $window.on(
            'scroll',
            throttle(function () {
                const $headerPromoBanner = $('.header-promo-banner');
                const $headerWrapper = $('.header-wrapper');

                const positionIOS = $window.scrollTop();
                if (positionIOS < 0) {
                    $headerPromoBanner.addClass('ios-overscrolling');
                    $headerWrapper.addClass('ios-overscrolling');
                } else {
                    $headerPromoBanner.removeClass('ios-overscrolling');
                    $headerWrapper.removeClass('ios-overscrolling');
                }
            }, 100)
        );

        $body.on('submit', '.ajax-login', async function (event) {
            event.preventDefault();

            const params = {
                format: 'ajax'
            };

            const $form = $(this);
            const $recaptcha = $form.find('.js-recaptcha');

            // Check if form has recaptcha enabled
            if ($recaptcha.length) {
                await googleRecaptcha.refreshRecaptchaElement($recaptcha);
            }

            const action = $form.attr('action');
            let formData = $form.serialize();

            formData += '&headerAjaxLogin=true';

            progress.show($('.header-user-flyout'));

            $.ajax({
                url: util.appendParamsToUrl(action, params),
                method: $form.attr('method'),
                data: formData,

                /**
                 * Asynchronous request success state
                 *
                 * @param {Object} response - response
                 */
                success(response) {
                    if (!response.error && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    } else {
                        $form.find('.message').remove();

                        $form.prepend(
                            $('<div />', {
                                class: 'message error-form',
                                text: response.error
                            })
                        );

                        captcha.resetCaptcha($form[0]);
                    }
                },

                /**
                 * Asynchronous request error state
                 *
                 * @returns {void}
                 */
                error: () => captcha.resetCaptcha($form[0]),

                /**
                 * Asynchronous request complete state
                 *
                 * @returns {void}
                 */
                complete: () => progress.hide()
            });
        });
    }
};

module.exports = header;
